import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import FilterBar from '../Components/FilterBar';
import FilterSide from '../Components/FilterSide';
import HeaderAdditionalMenu from '../Components/HeaderAdditionalMenu';
import HeaderNotifications from '../Components/HeaderNotifications';
import HeaderUser from '../Components/HeaderUser';
import WhatsAppFloatingButton from '../Components/WhatsAppFloatingButton';

function DefaultLayout({ children }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [types, setTypes] = useState([]);
    const [typesDownloads, setTypesDownloads] = useState([]);
    const menuRef1 = useRef(null);
    const menuRef2 = useRef(null);
    const menuRef3 = useRef(null);

    const location = useLocation();

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    useEffect(() => {
        const fetchTypes = async () => {
            let redirected = false;

            try {
                const [typesResponse, typesDownloadsResponse] = await Promise.all([
                    fetch(`${baseUrl}/painel/tipos`, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }),
                    fetch(`${baseUrl}/painel/tipos-downloads`, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }),
                ]);

                if (!typesResponse.ok || !typesDownloadsResponse.ok) {
                    throw new Error('Erro ao buscar os tipos ou os downloads.');
                }

                const typesData = await typesResponse.json();
                const typesDownloadsData = await typesDownloadsResponse.json();

                setTypes(typesData.tipos);
                setTypesDownloads(typesDownloadsData.tipos_downloads);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            }
        };

        fetchTypes();

        if (location.pathname.startsWith('/painel/pesquisar') && window.innerWidth > 768) {
            setIsFilterOpen(true);
        }

        const handleClickOutside = (event) => {
            const clickedInMenu = [menuRef1, menuRef2, menuRef3].some((ref) => ref.current && ref.current.contains(event.target));

            if (!clickedInMenu) {
                setOpenMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const noSearchRoutes = [
        '/painel/perfil',
        '/painel/area-do-representante/cases',
        '/painel/area-do-representante/ranking',
        '/painel/area-do-representante/aniversarios',
    ];

    return (
        <>
            <div className="flex h-screen overflow-hidden">
                <div className="relative flex-1 overflow-y-auto overflow-x-hidden">
                    <header
                        className="sticky top-0 z-50 flex w-full from-primary from-30% to-black border-b border-sky-100 border-opacity-30"
                        style={{ backgroundImage: 'linear-gradient(45deg, var(--tw-gradient-stops))' }}
                    >
                        <div className="container max-w-large">
                            <div className="flex flex-grow items-center justify-between py-3 2xl:py-9">
                                <div className="flex items-center w-full">
                                    <Link to="/painel" className="flex items-center">
                                        <img src={`/assets/img/rometal-logo.png`} alt="Logo" className="block max-w-56 2xl:max-w-64" />
                                    </Link>

                                    <div className="lg:hidden ml-auto mr-10 mt-1">
                                        <HeaderNotifications />
                                    </div>

                                    <div
                                        className={`fixed lg:relative max-lg:w-full max-lg:h-full max-lg:left-0 max-lg:top-0 flex max-lg:flex-col flex-grow items-center max-lg:justify-between max-lg:overflow-auto max-lg:bg-quaternary max-lg:translate-x-full transition-all duration-300${isMenuOpen ? ' max-lg:!translate-x-0' : ''}`}
                                    >
                                        <nav className="ml-0 lg:ml-14 xl:ml-28 max-lg:mb-auto max-lg:order-2">
                                            <ul className="flex max-lg:items-center flex-col lg:flex-row lg:gap-4 2xl:gap-12">
                                                <li>
                                                    <Link
                                                        to="/painel"
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out"
                                                    >
                                                        Home
                                                    </Link>
                                                </li>

                                                <li className="relative" ref={menuRef1}>
                                                    <button
                                                        onClick={() => toggleMenu('types')}
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out max-lg:mx-auto"
                                                    >
                                                        Produtos<span className="text-sm max-lg:hidden"> ▼</span>
                                                    </button>

                                                    <ul className="lg:hidden text-center -mt-2 mb-4">
                                                        {types.map((item, index) => (
                                                            <li key={index}>
                                                                <Link
                                                                    to={`/painel/produtos/${item.slug}`}
                                                                    className="block px-4 text-white"
                                                                >
                                                                    {item.nome}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>

                                                    {openMenu === 'types' && (
                                                        <ul className="max-lg:hidden absolute left-4 2xl:mt-2 w-48 bg-neutral-500 overflow-hidden shadow-lg rounded-lg">
                                                            {types.map((item, index) => (
                                                                <li key={index}>
                                                                    <Link
                                                                        to={`/painel/produtos/${item.slug}`}
                                                                        className="block px-4 lg:py-2 text-white hover:bg-white/10"
                                                                    >
                                                                        {item.nome}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>

                                                {/* <li className="relative hidden" ref={menuRef2}>
                                                    <button
                                                        onClick={() => toggleMenu("seller")}
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out"
                                                    >
                                                        Área do representante<span className="text-sm max-lg:hidden"> ▼</span>
                                                    </button>

                                                    <ul className="lg:hidden text-center -mt-2 mb-4">
                                                        <li>
                                                            <Link to="/painel/area-do-representante/ranking" className="block px-4 text-white">
                                                                Ranking
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/painel/area-do-representante/cases" className="block px-4 text-white">
                                                                Cases
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/painel/area-do-representante/aniversarios" className="block px-4 text-white">
                                                                Aniversariantes
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                    {openMenu === "seller" && (
                                                        <ul className="max-lg:hidden absolute left-4 2xl:mt-2 w-48 bg-neutral-500 overflow-hidden shadow-lg rounded-lg">
                                                            <li>
                                                                <Link to="/painel/area-do-representante/ranking" className="block px-4 py-1 sm:py-2 text-white hover:bg-white/10">
                                                                    Ranking
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/painel/area-do-representante/cases" className="block px-4 py-1 sm:py-2 text-white hover:bg-white/10">
                                                                    Cases
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/painel/area-do-representante/aniversarios" className="block px-4 py-1 sm:py-2 text-white hover:bg-white/10">
                                                                    Aniversariantes
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </li> */}

                                                <li className="relative" ref={menuRef2}>
                                                    <button
                                                        onClick={() => toggleMenu('downloads')}
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out max-lg:mx-auto"
                                                    >
                                                        Downloads<span className="text-sm max-lg:hidden"> ▼</span>
                                                    </button>

                                                    <ul className="lg:hidden text-center -mt-2 mb-4">
                                                        {typesDownloads.map((item, index) => (
                                                            <li key={index}>
                                                                <Link
                                                                    to={`/painel/downloads/${item.slug}`}
                                                                    className="block px-4 text-white"
                                                                >
                                                                    {item.nome}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>

                                                    {openMenu === 'downloads' && (
                                                        <ul className="max-lg:hidden absolute left-4 2xl:mt-2 w-48 bg-neutral-500 overflow-hidden shadow-lg rounded-lg">
                                                            {typesDownloads.map((item, index) => (
                                                                <li key={index}>
                                                                    <Link
                                                                        to={`/painel/downloads/${item.slug}`}
                                                                        className="block px-4 lg:py-2 text-white hover:bg-white/10"
                                                                    >
                                                                        {item.nome}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>

                                                <li className="relative" ref={menuRef3}>
                                                    <button
                                                        onClick={() => toggleMenu('news')}
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out max-lg:mx-auto"
                                                    >
                                                        News<span className="text-sm max-lg:hidden"> ▼</span>
                                                    </button>

                                                    <ul className="lg:hidden text-center -mt-2 mb-4">
                                                        <li>
                                                            <Link to="/painel/news/destaques" className="block px-4 text-white">
                                                                Destaques
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/painel/news/aniversarios" className="block px-4 text-white">
                                                                Aniversariantes
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                    {openMenu === 'news' && (
                                                        <ul className="max-lg:hidden absolute left-4 2xl:mt-2 w-48 bg-neutral-500 overflow-hidden shadow-lg rounded-lg">
                                                            <li>
                                                                <Link
                                                                    to="/painel/news/destaques"
                                                                    className="block px-4 py-1 sm:py-2 text-white hover:bg-white/10"
                                                                >
                                                                    Destaques
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/painel/news/aniversarios"
                                                                    className="block px-4 py-1 sm:py-2 text-white hover:bg-white/10"
                                                                >
                                                                    Aniversariantes
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </li>

                                                <li className="lg:hidden">
                                                    <a
                                                        href="https://rometal.com.br/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out"
                                                    >
                                                        Acessar Site
                                                    </a>
                                                </li>

                                                <li className="lg:hidden">
                                                    <a
                                                        href="https://rometal.com.br/rometalks"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out"
                                                    >
                                                        Acessar Rometalks
                                                    </a>
                                                </li>

                                                <li className="lg:hidden">
                                                    <Link
                                                        to="/painel/contato"
                                                        className="block text-md 2xl:text-md text-white font-medium uppercase p-2 sm:p-4 transition-all duration-200 ease-out"
                                                    >
                                                        Contato
                                                    </Link>
                                                </li>
                                            </ul>
                                        </nav>

                                        <div className="flex max-lg:w-full items-center lg:ml-auto max-lg:order-1 gap-3">
                                            <div className="max-lg:hidden">
                                                <HeaderAdditionalMenu />
                                            </div>

                                            <div className="max-lg:hidden">
                                                <HeaderNotifications />
                                            </div>

                                            <div className="max-lg:w-full">
                                                <HeaderUser />
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        className="absolute z-[20] top-10 right-[5%] transform -translate-y-1/2 lg:hidden"
                                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                                    >
                                        <div className="flex items-center">
                                            <div className="relative w-5 h-[14px]">
                                                <div
                                                    className={`absolute top-0 bg-white h-0.5 w-5 transition-all duration-300 ${isMenuOpen ? 'rotate-45 !top-[6px]' : ''}`}
                                                    style={{
                                                        transitionDelay: isMenuOpen ? '0ms, 400ms' : '0ms',
                                                        transitionProperty: 'top, transform',
                                                    }}
                                                ></div>
                                                <div
                                                    className={`absolute top-[6px] bg-white h-0.5 w-5 transition-all duration-300 ${isMenuOpen ? 'scale-x-0 !top-[6px]' : ''}`}
                                                    style={{
                                                        transitionDelay: isMenuOpen ? '0ms, 400ms' : '0ms',
                                                        transitionProperty: 'top, transform',
                                                    }}
                                                ></div>
                                                <div
                                                    className={`absolute bottom-0 bg-white h-0.5 w-5 transition-all duration-300 ${isMenuOpen ? '-rotate-45 bottom-[6px]' : ''}`}
                                                    style={{
                                                        transitionDelay: isMenuOpen ? '0ms, 400ms' : '0ms',
                                                        transitionProperty: 'bottom, transform',
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div
                        className="App relative before:content-[''] before:absolute before:inset-0 before:bg-tertiary before:opacity-10 before:-z-[1] from-primary from-30% to-black min-h-[calc(100vh_-_9.05em)] 2xl:min-h-[calc(100vh_-_12.35em)]"
                        style={{ backgroundImage: 'linear-gradient(10deg, var(--tw-gradient-stops))' }}
                    >
                        {!noSearchRoutes.some((path) => location.pathname.includes(path)) && (
                            <FilterBar isVisible={!isFilterOpen} setIsFilterOpen={setIsFilterOpen} />
                        )}
                        <div className="container max-w-large">
                            <div className="flex relative">
                                <div className={`overflow-hidden transition-all duration-500 ${isFilterOpen ? 'lg:w-[20%]' : 'max-w-0'}`}>
                                    <FilterSide isFilterOpen={isFilterOpen} setIsFilterOpen={setIsFilterOpen} />
                                </div>
                                <div className={`transition-all duration-500 ${isFilterOpen ? 'w-full lg:w-[80%] lg:pl-12' : 'w-full'}`}>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer
                        className="h-16 border-t border-sky-100 border-opacity-30 from-black to-tertiary"
                        style={{ backgroundImage: 'linear-gradient(45deg, var(--tw-gradient-stops))' }}
                    >
                        <div className="container max-w-large h-full">
                            <div className="flex h-full items-center justify-between max-sm:flex-col max-sm:py-2">
                                <span className="text-[10px] text-white opacity-50">© Rometal {new Date().getFullYear()}. Todos os direitos reservados.</span>
                                <span className="flex gap-3 items-center text-[10px] text-white opacity-50">
                                    Desenvolvido por:
                                    <img src={`/assets/img/8poroito-logo.png`} alt="logo autor" className="w-[70px]" />
                                </span>
                            </div>
                        </div>
                    </footer>

                    <WhatsAppFloatingButton />
                </div>
            </div>
        </>
    );
}

export default DefaultLayout;
